import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom'
import { setAddress } from '../../store/actions/restaurantActions'

class Settings extends Component {

  constructor(props) {
    super(props);
    this.state = {
    	address: '',
      state:'',
      zip:'',
      city:'',
      lat:0,
      lng:0,
      httpResponse:'',
      currentAddress:'',
      currentState:'',
      currentZip:'',
      currentCity:''
    };
  }

  componentDidMount(props){

    const success = position => {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      //console.log(latitude, longitude);
      if(this.state.mount){
        this.setState({
          lat: latitude,
          lng: longitude
        });  
      }
      this.getAddress([this.state.lat, this.state.lng]);
    };

    const error = () => {
      alert("Unable to retrieve your location");
    };

    navigator.geolocation.getCurrentPosition(success, error);

    this.setState({mount:true});

  }

  componentDidUpdate(){
    
    if(this.state.httpResponse !== '' & this.state.currentAddress===''){
      console.log(this.state.httpResponse['resourceSets'][0]['resources'][0]['address'])

      var currentCity = ""
      if(this.state.httpResponse['resourceSets'][0]['resources'][0]['address']['adminDistrict2']==="Richmond City"){
        currentCity="Richmond"
      }
      else{
        currentCity=this.state.httpResponse['resourceSets'][0]['resources'][0]['address']['adminDistrict2'];
      }

      this.setState({
        currentAddress:this.state.httpResponse['resourceSets'][0]['resources'][0]['address']['addressLine'],
        currentState:this.state.httpResponse['resourceSets'][0]['resources'][0]['address']['adminDistrict'],
        currentZip:this.state.httpResponse['resourceSets'][0]['resources'][0]['address']['postalCode'],
        currentCity:currentCity
      })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  handleCurrentLocation = (e) => {
    //console.log([this.state.lat, this.state.lng]);
    if(this.state.lat !== 0 && this.state.currentAddress !== ''){
      this.props.setAddress(this.state.currentState, this.state.currentZip, this.state.currentCity, this.state.currentAddress,[this.state.lat,this.state.lng],this.props.user);
    }
  }

  getAddress = (location) => {
    var point = location.toString();
    console.log(point);
    const Http = new XMLHttpRequest();
    if(point !== "0,0"){
      var url = 'https://dev.virtualearth.net/REST/v1/Locations/'+location[0]+','+location[1]+'?&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O';

      Http.open("GET", url);
      Http.send();
      const that = this;

      Http.onreadystatechange=function(){
        if(this.readyState === 4 && this.status === 200 && that.state.httpResponse !== Http.responseText){
          var parsedJSON = JSON.parse(Http.responseText);
          that.setState({httpResponse:parsedJSON})
        }
      }
    }
  }


  locateInterruptor = (e) => {
    e.preventDefault();

    if(this.state.state !== '' && this.state.zip !== '' && this.state.city !== '' && this.state.address !== '' ){
      
      var newAddress = this.state.address;
      var newState = this.state.state;
      var newCity = this.state.city;
      var newZip = this.state.zip;

      var itemArray = [newAddress, newState, newCity, newZip];
      var shouldTest = [true,true,true,true];
      var falseTest = [false,false,false,false];

      while(JSON.stringify(shouldTest) != JSON.stringify(falseTest)){
        for(var item in itemArray){
          if(shouldTest[item]){ 
            if(itemArray[item].charAt(itemArray[item].length-1)=='.' ||
              itemArray[item].charAt(itemArray[item].length-1)==' ' ||
              itemArray[item].charAt(itemArray[item].length-1)==','
              ){
              itemArray[item] = itemArray[item].slice(0,-1);
            }
            else{
              shouldTest[item] = false;
            }
          }
        }  
      }

      this.calculateLocation(itemArray[1], itemArray[3], itemArray[2], itemArray[0]);
      console.log('location');
      console.log(this.state.location);
    }

    //this.calculateLocation(this.state.state, this.state.zip, this.state.city, this.state.address);
    document.getElementById("locateModal").style.display = "block";
  }

  closeFunctionLocate =(e)=>{document.getElementById("locateModal").style.display = "none";}

  handleLocate = (e) => {
    e.preventDefault();
    this.props.setAddress(this.state.state, this.state.zip, this.state.city, this.state.address, this.state.location, this.props.user);
    
    document.getElementById("locateModal").style.display = "none";
    document.getElementById('address-input').style.display = "none"; 
  }

  calculateLocation = (state, zip, city, address) => {

    const Http = new XMLHttpRequest();
    const addressEncoded = encodeURIComponent(address);

    const url='https://dev.virtualearth.net/REST/v1/Locations/US/'+state+'/'+zip+'/'+city+'/'+addressEncoded+'?&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O';

    Http.open("GET", url);
    Http.send();
    const that = this;

    Http.onreadystatechange=function(){
      if(this.readyState === 4 && this.status === 200 && that.state.httpResponse !== Http.responseText){
        var parsedJSON = JSON.parse(Http.responseText);
        that.setState({httpResponse:parsedJSON})
        if(that.state.httpResponse !== ''){
          that.setState({location: that.state.httpResponse.resourceSets[0].resources[0].geocodePoints[0].coordinates});
          that.setState({route:''});
        }
      }
      else{console.log('notready')}
    }
  }

  handleAddress = (e) => {
    e.preventDefault();
    if(document.getElementById('address-input').style.display==='none' || document.getElementById('address-input').style.display===''){
      document.getElementById('address-input').style.display = "block";  
    }
    else{
      document.getElementById('address-input').style.display = "none"; 
    }  
  }

  render(){
  	const {auth, user} = this.props
  	if (!auth.uid) return <Redirect to='/signin' />
  
  	return(
  		
  		<div className='container' style={{display:"flex", justifyContent:"center"}}>

        <div id="locateModal" className="modal2">
          <div className="modal-content2">
            <span className="close2" onClick={this.closeFunctionLocate}>&times;</span>
          { !this.state.location &&
            <div>
              <p>The address form has not been acceptably filled.</p>
              <p>Make sure all fields have values and remove any symbols</p>
              <p>If you would like to use the default address, turn off location sharing and
                click "USE CURRENT LOCATION"</p>
            </div>
          }
          { this.state.location && 
            <div>
              <p>Are you sure you want to update address?</p>
              <p>{this.state.address}</p>
              <p>{this.state.location}</p>
              <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                <button className="btn pink lighten-1" onClick={this.handleLocate}>Update</button>
              </div>
            </div>
          }
            
          </div>
        </div>

  		{ auth && user && user.firstName !== "Guest" &&
        <div className="stopMarginBlockP" style={{display: "flex", justifyContent: "space-around", flexFlow: "column", textAlign: 'center', marginTop:"20px", maxWidth:"400px", minWidth:"320px"}}>
          <div>
          <h4>Address</h4>
          <p>{ user.address }</p>
          <p>{user.city + ", " + user.state + " " + user.zip}</p>
          <button className="btn pink lighten-1" id='changeAddress' onClick={this.handleAddress} >Change Address</button>    

        <div className="address-input" id='address-input'>
          <form className="address-form" style={{marginTop:"0px"}} onSubmit={this.handleSubmit}>
            <div className="input-field">
              <label htmlFor="address">Address</label>
              <input style={{color:"black"}} type="text" id='address' onChange={this.handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="city">City</label>
              <input style={{color:"black"}} type="text" id='city' onChange={this.handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="state">State</label>
              <input style={{color:"black"}} type="text" id='state' onChange={this.handleChange} />
            </div>
            <div className="input-field">
              <label htmlFor="zip">Zip</label>
              <input style={{color:"black"}} type="text" id='zip' onChange={this.handleChange} />
            </div>
            <div className="input-field">
              <button className="btn pink lighten-1 z-depth-0" onClick={this.locateInterruptor}>Update Address</button>
            </div>
          </form>
        </div>
        </div>
        <div style={{paddingTop:"20px"}}>
          <button className="btn pink lighten-1" id='currentLocation' onClick={this.handleCurrentLocation} >Use Current Location</button>        
        </div>
        </div>
      }
      {
        auth && user && user.firstName === "Guest" &&
        <div className="stopMarginBlockP" style={{display: "flex", justifyContent: "space-around", flexFlow: "column", textAlign: 'center', marginTop:"20px", maxWidth:"400px", minWidth:"320px"}}>
          <div>
            <h4>Address</h4>
            <p>{ user.address }</p>
            <p>{user.city + ", " + user.state + " " + user.zip}</p>
            <p>Guest Users can not enter an address</p>        
          </div>
          <div style={{paddingTop:"20px"}}>
            <button className="btn pink lighten-1" id='currentLocation' onClick={this.handleCurrentLocation} >Use Current Location</button>        
          </div>
        </div>
      }
  		</div>

  	)
  }

}

const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setAddress: (state, zip, city, address, location, user) => dispatch(setAddress(state, zip, city, address, location, user))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)